import(/* webpackMode: "eager" */ "/data/apps/algo-dashboard/src/app/(app)/control/page.tsx");
